<template>
  <div id="app">
    <transition name="scale">
      <router-view/>
    </transition>
    <Mum v-if="showMum" />
    <Hint v-if="hintMsg" />
  </div>
</template>

<script>
// @ is an alias to /src
import Mum from '@/components/Mum.vue'
import Hint from '@/components/Hint.vue'
import { mapActions, mapGetters } from 'vuex'
import { shareOption } from './lib/config.js'
import { commonShare } from './service/bridge.js'
import wxShare from 'weixin-share2'

export default {
  name: 'home',
  components: {
    Mum,
    Hint
  },
  computed: mapGetters({
    showMum: 'showMum',
    hintMsg: 'hintMsg'
  }),
  methods: mapActions({
    switchMum (dispatch) {
      const showMum = this.showMum
      dispatch('switchMum', !showMum)
    },
    playMsg (dispatch) {
      dispatch('playMsg', '显示一个消息看看')
    }
  }),
  mounted () {
    const vm = this;

    // 微信二次分享
    wxShare.config({
      title: shareOption.title,
      desc: shareOption.des,
      link: shareOption.link,
      imgUrl: shareOption.img
    })

    const path = location.hash

    vm.$store.dispatch('getUserInfo');
    commonShare(function(){
      vm.$store.dispatch('shareFun')
    })

    const CodoonNativeBridge = window.codoonNativeBridge
    const bridge = new CodoonNativeBridge()

    bridge.nativeSetTitleBar({ title_color: '#ffffff', bar_color: '#04751d' })
  }
}
</script>

<style lang="scss">
  @import url('./assets/styles/reset.scss');
</style>
